import React from "react";

import { getCurrentLanguage } from "../../../../../utils/software";
class SubtitleSearchBlock extends React.Component 
{
    
    constructor(props) {
        super(props);

        this.state = {
            alignment: "center",
            applyAlignment: false,

            color: "#FFFFFF",
            applyColor: false
        };

        this.currentLanguage = getCurrentLanguage();

        this.blocks = [
            {
                title: this.langsel("Alignement","Alignment"),
                valueKey: "alignment",
                applyKey: "applyAlignment",
                options: [
                    { value: "left", label: this.langsel("Gauche","Left") },
                    { value: "center", label: this.langsel("Centre","Center") },
                    { value: "right", label: this.langsel("Droite","Right") },
                    { value: "free", label: this.langsel("Libre","Free") }
                ]
            },
            {
                title: this.langsel("Couleur","Color"),
                valueKey: "color",
                applyKey: "applyColor",
                options: [
                    { value: "#0000FF", label: this.langsel("Bleu","Blue"), color: "#0000FF" },
                    { value: "#00FF00", label: this.langsel("Vert","Green"), color: "#00FF00" },
                    { value: "#00FFFF", label: "Cyan", color: "#00FFFF" },
                    { value: "#FF0000", label: this.langsel("Rouge","Red"), color: "#FF0000" },
                    { value: "#FF00FF", label: "Magenta", color: "#FF00FF" },
                    { value: "#FFFF00", label: this.langsel("Jaune","Yellow"), color: "#FFFF00" },
                    { value: "#FFFFFF", label: this.langsel("Blanc","White"), color: "#FFFFFF" }
                ]
            }
        ];
    }

    langsel(fr,en)
    {
        return this.currentLanguage=="fr"?fr:en;
    }

    handleChange = (block, value) => {
        this.setState({
            [block.valueKey]: value,
            [block.applyKey]: true
        });
    };

    getValues()
    {
        return this.state;
    }

    renderBlock(block) {
        return (
            <div
                key={block.valueKey}
                style={{
                    display: "flex",
                    alignItems: "center",
                    width: "97%",
                    marginBottom: "8px",
                    fontSize: "12px",
                    color: "#FFFFFF"
                }}
            >
                <div
                    style={{
                        width: "85px",
                        flexShrink: 0
                    }}
                >
                    {block.title}
                </div>

                <select
                    value={this.state[block.valueKey]}
                    onChange={(e) =>
                        this.handleChange(block, e.target.value)
                    }
                    style={{
                        flex: 1,
                        height: "22px",
                        background: "#202020",
                        color: "#FFFFFF",
                        border: "1px solid #666",
                        borderRadius: "4px",
                        fontSize: "12px",
                        marginRight: "10px"
                    }}
                >
                    {block.options.map((o) => (
                        <option
                            key={o.value}
                            value={o.value}
                            style={{
                                color: o.color || "#FFFFFF",
                                background: "#202020"
                            }}
                        >
                            {o.label}
                        </option>
                    ))}
                </select>

                <label
                    style={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        userSelect: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <input
                        type="checkbox"
                        checked={this.state[block.applyKey]}
                        onChange={(e) =>
                            this.setState({
                                [block.applyKey]: e.target.checked
                            })
                        }
                        style={{ marginRight: "4px" }}
                    />
                    {this.langsel("Rechercher","Search")}
                </label>
            </div>
        );
    }

    render() {
        return (
            <div
                style={{
                    width: "100%",
                    background: "transparent",
                    padding: "4px",
                    boxSizing: "border-box",
                    fontFamily: "Arial, sans-serif"
                }}
            >
                {this.blocks.map((block) => this.renderBlock(block))}
            </div>
        );
    }
}

export default SubtitleSearchBlock;